import { render, staticRenderFns } from "./SimpleTableView.vue?vue&type=template&id=dbcd9b18&"
import script from "./SimpleTableView.vue?vue&type=script&lang=js&"
export * from "./SimpleTableView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports